import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { APICore } from '../helpers/api/apiCore';

const Root = () => {
    const api = new APICore();
    const { needsWorkspaceSelection } = useSelector((state: RootState) => state.Auth as any);
    const { activeWorkspace } = useSelector((state: RootState) => state.Workspace);

    const getRootUrl = (): string => {
        if (!api.isUserAuthenticated()) {
            return 'auth/login';
        }
        
        // If multiple workspaces and none selected yet, show selector
        const hasActiveWorkspace = activeWorkspace || localStorage.getItem('active_workspace');
        if (needsWorkspaceSelection && !hasActiveWorkspace) {
            return 'workspace/select';
        }
        return 'dashboard/ecommerce';
    };

    const url = getRootUrl();
    return <Redirect to={`/${url}`} />;
};

export default Root;
